/**
 * Render a google maps map.
 *
 * @param $el jQuery element.
 */
function render_map($el) {
	// vars
	var args = {
		zoom: 16,
		center: new google.maps.LatLng($el.data('lat'), $el.data('lng')),
		mapTypeId: google.maps.MapTypeId.ROADMAP
	};

	// create map
	var mapEl = document.getElementById('map');
	var map = new google.maps.Map(mapEl, args);

	jQuery(mapEl).addClass('active-map');

	add_marker($el, map);
}


/**
 * Add a marker to the selected Google Map.
 *
 * @param $marker jQuery element.
 * @param map     Google Map object.
 */
function add_marker($marker, map) {

	// var
	var latlng = new google.maps.LatLng($marker.data('lat'), $marker.data('lng'));

	// create marker
	var marker = new google.maps.Marker({
		position: latlng,
		map: map
	});

	var infowindow = new google.maps.InfoWindow({
		content: $marker.data('address')
	});

	// show info window when marker is clicked
	google.maps.event.addListener(marker, 'click', function () {

		infowindow.open(map, marker);

	});

}


/**
 * The global NidApp object
 */
var NidApp = {
	moodboardMouseEnterParams: {
		mouseenter: function (e) {
			jQuery(this).find('span').fadeIn(100);
		},
		mouseleave: function (e) {
			jQuery(this).find('span').fadeOut(50);
		}
	},
	$moodboards: null,
	termsContainerHeight: null
};


/**
 * Render a modal dialog for a product.
 *
 * @param {string} sku Product SKU.
 *
 * @return {string} The markup required for the dialog.
 */
NidApp.renderProductPopupInformation = function (productId, colorId, modal) {
	var deferred = jQuery.Deferred();

	colorId = (typeof colorId !== 'undefined') ? colorId : 0;
	if ('' === colorId) {
		colorId = 0;
	}
	modal = (typeof modal !== 'undefined') ? modal : 1;

	jQuery.ajax({
		type: 'POST',
		url: nordsjo.ajaxurl,
		data: {
			'action': 'nid_woo_ajax_get_product_by_id',
			'product_id': productId,
			'color_id': colorId,
			'modal': modal,
			'nid_fast_ajax': 1
		}
	}).done(function (result) {
		deferred.resolve(result);

	});

	return deferred.promise();
};


/**
 * Fetch products via AJAX.
 *
 * @param {object} query Query vars to pass to WP_Query/get_posts call.
 *
 * @return string
 */
NidApp.renderProducts = function (args) {
	var deferred = jQuery.Deferred();

	jQuery.ajax({
		type: 'POST',
		url: nordsjo.ajaxurl,
		data: {
			action: 'nid_woo_ajax_render_product_listing',
			args: args,
			nid_fast_ajax: 1
		}
	}).done(function (result) {
		deferred.resolve(result);
	});

	return deferred.promise();
};


/** Hide loading icon */
NidApp.removeLoadingIcon = function () {
	jQuery(document.getElementById('loading-screen-icon')).remove();

};


/**
 * Show loading icon
 */
NidApp.showLoadingIcon = function () {
	if (null !== document.getElementById('loading-screen-icon')) {
		NidApp.removeLoadingIcon();
	}

	var centered = jQuery(window).scrollTop() + (jQuery(window).height() / 2) - 30;

	jQuery('<div />', {id: 'loading-screen-icon', height: jQuery(document).height()})
		.css({'background-position': 'center ' + centered + 'px'})
		.appendTo(jQuery('body'))
		.hide()
		.fadeIn(100);
};


/**
 * Show a success/error message.
 *
 * @param {string} message The message to display.
 * @param {string} type    The message type: 'error' if it's bad news.
 */
NidApp.showMessage = function (message, type) {
	if (typeof type === 'undefined') {
		type = 'success';
	}

	var $message = jQuery('#ajax-feedback'),
		icon = ('success' === type) ? '&#10003;' : '&times;',
		$template;

	if ($message.length) {
		$message.remove();
	}

	$template = jQuery('<div id="ajax-feedback" class="' + type + '"><span class="icon">' + icon + '</span> <span class="message">' + message + '</span></div>')
		.prependTo(jQuery('body'))
		.hide()
		.fadeIn(200)
		.on('click', function () {
			jQuery(this).remove();
		});


	setTimeout(function () {
		$template.fadeOut(300, function () {
			jQuery(this).remove();
		});
	}, 3500);

};


/**
 * Very simple AJAX helper that shows the result of the call as a message.
 *
 * @param {object} data Properties to add to the AJAX request.
 */
NidApp.ajax = function (data) {
	NidApp.showLoadingIcon();

	jQuery.post(nordsjo.ajaxurl, data, function (result) {
		NidApp.removeLoadingIcon();

		if (typeof result.data === 'undefined') {
			return;
		}

		if (true === result.success) {
			NidApp.showMessage(result.data.message);

		} else {
			NidApp.showMessage(result.data.message, 'error');

		}
	});
};


/**
 * An AJAX helper, that shows a loading spinner and returns the result.
 *
 * @param {object} data Properties to add to the AJAX request.
 * @return object  Result of the AJAX call.
 */
NidApp.doAjaxCall = function (data) {
	NidApp.showLoadingIcon();
	var deferred = jQuery.Deferred();

	jQuery.post(nordsjo.ajaxurl, data, function (result) {
		NidApp.removeLoadingIcon();

		if (typeof result.data !== 'undefined' && typeof result.success !== 'undefined') {

			if (true === result.success) {
				NidApp.showMessage(result.data.message);

			} else {
				NidApp.showMessage(result.data.message, 'error');

			}

		}

		deferred.resolve(result);
	});

	return deferred.promise();
};


/**
 * Generate the arguments for flexslider depending on context and
 * screen width.
 *
 * @param {object} $el        HTML element.
 * @param {bool}   isWishlist If true, the carousel on the wishlist page.
 */
NidApp.getProductSliderArgs = function ($el, isWishlist) {
	var maxItems = 1,
		winWidth = jQuery(window).width(),
		elWidth = $el.width(),
		args,
		itemWidth;

	if (winWidth > 710) {
		if (winWidth < 1125) {
			maxItems = 3;
		} else {
			if (typeof isWishlist !== 'undefined' && true === isWishlist) {
				maxItems = 5;
			} else {
				maxItems = 4;
			}
		}
	}

	itemWidth = Math.floor(elWidth / maxItems) - 10;

	args = {
		animation: 'slide',
		animationLoop: false,
		itemWidth: itemWidth,
		slideshow: false,
		itemMargin: 5,
		minItems: 1,
		maxItems: maxItems,
		smoothHeight: false
	};


	if (typeof isWishlist !== 'undefined' && true === isWishlist) {
		args.itemMargin = 10;
	}

	return args;
};

/**
 * Update all elements with content based on their data-global-key
 *
 * @param key
 * @param value
 */
NidApp.updateGlobals = function(key, value) {
	jQuery('[data-global-key="' + key + '"]').html(value);
}

/**
 * Add a product to the wishlist
 */
NidApp.addProductToCart = function (e) {
	e.preventDefault();

	let $this = jQuery(e.currentTarget)

	let payload = {
		product_id: $this.attr('data-id'),
		variation_id: $this.attr('data-variation-id'),
		quantity: $this.attr('data-quantity'),
		product_meta: {
			accCode:    $this.attr('data-acc-code'),
			rgb:        $this.attr('data-rgb'),
			colourName: $this.attr('data-colour-name'),
			imageSmall: $this.attr('data-image-small'),
			imageLarge: $this.attr('data-image-large')
		}
	}

	NidApp.showLoadingIcon();

	jQuery.ajax({
		url: nordsjo.ajaxurl + '?action=nid_add_to_cart',
		type: 'POST',
		dataType: 'json',
		data: JSON.stringify(payload)
	}).then(function (res) {
		NidApp.removeLoadingIcon();

		if (res.data) {
			if (res.data.message) {
				NidApp.showMessage(res.data.message, res.success ? 'success' : 'error');
			}

			// Update counter
			if (res.data.meta && res.data.meta.count) {
				NidApp.updateGlobals('cart-count', res.data.meta.count);
			}

		}

	});

};


/**
 * Update the wishlist counter when an item is added/removed
 */
/*NidApp.updateWishlistItemCount = function (decrement) {
	var $counter = jQuery(document.getElementById('wishlist-counter'));
	var numItems = +$counter.text();

	if (typeof decrement === 'undefined') {
		numItems++;
	} else {
		numItems--;
	}

	$counter.text(numItems);
};*/


/**
 * Simple AJAX helper
 */
NidApp.jqueryPost = function (data) {
	var deferred = jQuery.Deferred();

	jQuery.post(nordsjo.ajaxurl, data, function (result) {
		deferred.resolve(result);

	});

	return deferred.promise();
};


/** Add an image or a colour to a moodboard */
NidApp.addItemToMoodboard = function (e) {
	e.preventDefault();

	var $el = jQuery(e.currentTarget),
		data = {
			type: $el.attr('data-type'),
			networkPost: '0',
			id: false,
			imageUrl: false,
			nid_fast_ajax: 1
		},
		networkPost = $el.attr('data-network-post'),
		imageUrl;

	if (typeof networkPost !== 'undefined' && false !== networkPost) {
		data.networkPost = networkPost;
	}

	if (data.type === 'colour') {
		data.text = $el.attr('data-text');
		data.rgb = $el.attr('data-rgb');

	} else {
		data.imageUrl = $el.attr('data-url');
		data.imageId = $el.attr('data-image-id');
		data.id = $el.attr('data-id');

	}

	NidApp.showLoadingIcon();

	if (typeof data.imageUrl === 'undefined' && false !== data.imageUrl) {
		imageUrl = NidApp.jqueryPost({
			image_id: data.imageId,
			network_post: data.networkPost,
			action: 'nid_get_image_url'
		});
		jQuery.when(imageUrl).done(function (result) {
			data.imageUrl = result.data;
			NidApp.getMoodboards(data);
		});

	} else {
		NidApp.getMoodboards(data);

	}

};


/**
 * Retrieve a list of moodboards and open them in a modal dialogue.
 *
 * @param {object} data Object with properties for an image or a colour
 *                      that will be added to a moodboard.
 */
NidApp.getMoodboards = function (data) {
	var $toggle = jQuery(document.getElementById('new-modal-mb'));

	if (null === NidApp.$moodboards) {
		// The logged in check we can implement some time in the future,
		// when all the transient moodboards has expired in any case.
		if (jQuery('body').hasClass('logged-in')) {

			var moodboards = NidApp.jqueryPost({action: 'ajax_get_moodboards', nid_fast_ajax: 1});
			jQuery.when(moodboards).done(function (result) {
				NidApp.removeLoadingIcon();

				if (true === result.success) {
					NidApp.$moodboards = jQuery(result.data);

					$toggle.addClass('hide');
					NidApp.moodbordCallback(data);

				} else {
					NidApp.showMessage(result.data.message, 'error');

				}

			});

		} else {
			NidApp.removeLoadingIcon();
			NidApp.$moodboards = _.template(jQuery('#moodboard-cookie-template').html());
			$toggle.addClass('hide');
			NidApp.moodbordCallback(data);
		}

	} else {
		NidApp.removeLoadingIcon();
		NidApp.moodbordCallback(data);
	}

};


/**
 * Callback to open moodboards in a modal dialog.
 *
 * @param {object} data Object with properties for an image or a colour
 *                      that will be added to a moodboard.
 */
NidApp.moodbordCallback = function (data) {
	var $modal = jQuery(document.getElementById('moodboard-modal')),
		$list = jQuery('.moodboard-selector', $modal);

	$modal.modal().data('type', data.type).find('.add-to-mb-btn').remove();

	if ('image' === data.type) {
		$modal
			.data('image-id', data.id)
			.data('id', data.id)
			.data('image-url', data.imageUrl);

	} else {
		$modal
			.data('rgb', data.rgb)
			.data('text', data.text);

	}

	jQuery('li.add-to-mb-btn', $list).remove();
	$list.prepend(NidApp.$moodboards);
	jQuery('span.check').css({opacity: '0'});
};


/**
 * Calulate the height of a list in the dom against the height
 * of the list's parent element.
 *
 * Add a toggle if the list is taller than the parent.
 *
 * @param {object} $list HTML element for which to calculat the hight.
 */
NidApp.calcListHeight = function ($list) {
	if (null === NidApp.termsContainerHeight) {
		NidApp.termsContainerHeight = jQuery('.terms-list').eq(0).height() + 25; // Margin for error
	}

	if ($list.height() > NidApp.termsContainerHeight) {
		if (!$list.hasClass('has-toggle')) {
			var $link = jQuery('<a href="#" class="terms-toggle" />');

			$list.before($link).addClass('has-toggle');
		}
	}

};

/**
 * Check to see if localStorage is available.
 */
NidApp.checkIfLocalStorageAvailable = function () {
	var test = 'nordssjo_ls_test';
	try {
		localStorage.setItem(test, test);
		localStorage.removeItem(test);
		return true;
	} catch (e) {
		return false;
	}
};


/**
 * Check to see if there is a moodboard saved as a transient
 * and convert it to localStorage if so.
 */
NidApp.maybeConvertTransientMoodboardToLocalStorage = function () {
	if (false === NidApp.checkIfLocalStorageAvailable()) {
		return;
	}
	var lsFlag = 'nidHasConvertedTransient';

	if ('yes' !== localStorage.getItem(lsFlag)) {
		var ajaxRequest = NidApp.jqueryPost({action: 'get_moodboard_transient'});
		jQuery.when(ajaxRequest).done(function (result) {
			// console.log( result );
			// If there is a result, save it to localStorage.
			if ('' !== result) {
				localStorage.setItem('moodboardCookie', result);
			}
			localStorage.setItem(lsFlag, 'yes');
		});
	}

};

NidApp.maybeConvertTransientMoodboardToLocalStorage();

export default NidApp;
